import type {ModelYearResponseBody} from '@dms/api/new-vehicle';

import {joinParts, t} from './catalogueUi';

/** Omnetic's price list version, then the importer's catalogue ID and UPP when set: the references dealers and the importer quote. */
export const pricelistParameters = (year: ModelYearResponseBody | undefined) => {
  const references = joinParts([
    year?.importerPriceList.catalogueId,
    year?.importerPriceList.priceListVersion,
  ]);
  return [
    `${t('entity.newVehicle.catalogue.pricelistVersion', 'Pricelist version')} ${year?.pricelistVersionLabel ?? '—'}`,
    ...(references === ''
      ? []
      : [
          `${t('entity.newVehicle.catalogue.importerPriceList.title', 'Importer price list')} ${references}`,
        ]),
  ];
};
